import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { PessoaDomain } from '@/core/api/sicom-api/registro/pessoa/pessoa.domain';
import { ReturnRouteService } from '@/core/services/return-route.service';
import { PessoaService } from '@/shared/services/pessoa.service';

export const ABRIR_PRESTADOR_RETURN_CONTEXT_ID = 'abrir-prestador';

/**
 * Abre o dashboard de OUTRO prestador (a partir de uma tabela do próprio módulo), mantendo o botão
 * global "Voltar para o prestador anterior". Espelha `PrestadorFinanceiroNavigationService`, mas o
 * destino é o próprio módulo `/prestadores` (não `/arrecadacao`) — por isso `targetUrl` é `/prestadores`.
 * A restauração do prestador de origem é feita apenas na perna de retorno pelo dashboard, que trata a
 * particularidade de origem e destino compartilharem o mesmo módulo.
 */
@Injectable({ providedIn: 'root' })
export class PrestadorAberturaNavigationService {
    constructor(
        private readonly pessoaService: PessoaService,
        private readonly returnRouteService: ReturnRouteService,
        private readonly router: Router
    ) {}

    abrirPrestador(prestadorAtual: PessoaDomain | undefined, alvo: PessoaDomain, returnUrl: string): void {
        if (!prestadorAtual?.id || !prestadorAtual.uf || !alvo.id || !alvo.uf) {
            return;
        }

        this.returnRouteService.registrar({
            id: ABRIR_PRESTADOR_RETURN_CONTEXT_ID,
            label: 'Voltar para o prestador anterior',
            returnUrl,
            createdFromUrl: returnUrl,
            targetUrl: '/prestadores',
            payload: prestadorAtual
        });
        this.pessoaService.setPessoa({ ...alvo, tipo: 'PRESTADOR' });
        void this.router.navigate(['/prestadores', 'dados-gerais'], { queryParams: { returnContext: ABRIR_PRESTADOR_RETURN_CONTEXT_ID } });
    }
}
